import './Home.css'
import ParagraphPanel from '../components/ParagraphPanel';
import MainCarousel from '../components/MainCarousel';
import { Accordion, Button, Card, Col, Image, Row } from 'react-bootstrap';
import { useState, useCallback } from 'react';
import GodotGame from '../components/GodotGame';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faGithub, faItchIo} from '@fortawesome/free-brands-svg-icons';

export default function Home() {
  const [isSoftware, setIsSoftware] = useState(false);
  const [isGames, setIsGames] = useState(false);
  const [openFishGame, setOpenFishGames] = useState(false);

  const onClickFish = useCallback(() => {
    setOpenFishGames(!openFishGame);
  }, [openFishGame, setOpenFishGames]);

  return (
    <div className="App">
      <ParagraphPanel
        titlePanel="Full-Stack Software Developer"
        textPanel={
          <>
          <p>Most Recently: Java/Spring/React Dev, UE5 Build Engineer, .NET Developer</p>
          {
            (window.screen.width < 450) && (
            <>
              <a className='linkedIn' href="https://www.linkedin.com/in/irene-mayor/">
                  <FontAwesomeIcon className="iconShrink" icon={faLinkedin} color="#003049"  size="3x"/>
              </a>
              <a className='itch' href="https://ihmayor.itch.io">
                  <FontAwesomeIcon className="iconShrink" icon={faItchIo} color="#003049"  size="3x"/>
              </a>
              <a className='git' href="https://github.com/Ihmayor">
                  <FontAwesomeIcon className="iconShrink" icon={faGithub} color="#003049" size="3x"/>
              </a>
            </>)
          }
          </>}
        borderVariant="default"
      />
      <div className="MainContent">
        <div>
          <Row>
            <Col>
              <h4 className="AboutMeTitle">
                Located in Vancouver. If you have a collaborative team needing a <span className="ColorBold"><b>programmer who's driven, communicative and well-experienced in solving and optimizing complex multi-platform problems to unblock others</b></span> then let's connect!
                <br /><br />
              </h4>
              <Row>
                <Col>
                  <Card style={{ minHeight: "240px" }}>
                    <Row>
                      <Col>
                        <Card.Img variant="bottom" style={{ alignItems: "center", alignContent: "center", maxWidth: "100px", paddingTop:"2em"}} src="images/Software.png"  />
                      </Col>
                    </Row>
                    <Card.Body>
                      <Card.Title>General Software Development</Card.Title>
                      <Card.Text>Variety is my specialty! Back-end? Desktop? Web? Doesn't matter!</Card.Text>
                      <Button className='btn-outline-primary' variant="" href={'/Irene_Mayor_Resume_2025_Current.pdf'}>See More Details</Button>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card style={{ minHeight: "240px" }}>
                    <Row>
                      <Col>
                        <Card.Img variant="bottom" style={{ alignItems: "center", alignContent: "center", maxWidth: "100px", paddingTop:"2em" }} src="images/games.png"  />
                      </Col>
                    </Row>
                    <Card.Body>
                      <Card.Title>Game Development</Card.Title>
                      <Card.Text>Passionate about behind-the-scenes work that brings fun stories to life!</Card.Text>
                      <Button className='btn-outline-primary' variant="" style={{ marginRight: "10px" }} href={'/Irene_Mayor_Resume_2025_Games.pdf'}>See More Details</Button>
                      <Button className='btn-outline-primary' variant="" href={'/Games'}>Check Out My Games</Button>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
                <Row style={{padding:"12px"}}>
                  <Card style={{ width:"100%", display: openFishGame ? "block" : "none" }} >
                    <Row>
                      <Col>
                        <GodotGame />
                      </Col>
                    </Row>
                  </Card>
                </Row>
            </Col>
          </Row>

          <div className="AccordionParagraph">
            <Accordion defaultActiveKey="1">
              <Accordion.Item eventKey="0">
                <Accordion.Header>My Passion</Accordion.Header>
                <Accordion.Body>
                  I love <b>creating the technical foundations behind the scenes </b>that provides <b>ease of use for users</b> to facilitate the process of developing or working with the system, whether that be creative projects or otherwise. <i>Technology should adapt to people, not the other way around</i> is one of my driving mottos. The most satisfying thing about making software is hearing how I've made something helpful or made things easier for someone else.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>My Work Experience</Accordion.Header>
                <Accordion.Body>
                  I have been programming for over eight years, six years of work experience, two of which have been in Games. I love adapting to whatever opportunies are presented to me and dive headfirst into a diverse range of technologies. Give me a few weeks, and you'll be suprised on how quickly I intergrate and absorb the domain! I have multiple years working with a variety of Game Engines, like Unity, Godot and a bit of Unreal.
                  <br />
                  <br />
                  Currently, I am a Full-Stack Software Developer at <b>Avanti Software Inc.</b> for their HCM software designed to simplify the work for HR and Payroll.
                  Before that, I worked at <b>Timbre Games Studio</b> where I was a <b>Build Engineer</b> for their CI/CD pipelines in <b>TeamCity</b> and Perforce for a <b>UE5</b> project targeting PC/Consoles such as <b>Nintendo Switch</b>. I would've loved to continue growing there but unfortunately it was shut down by our parent company, Sumo Digital.
                  I've also worked at <b>Powerex Corp (Subsidiary of BCHydro)</b> as a <b>.NET Developer</b> working on <b>.NET Framework</b> solutions, <b>React</b> Web Apps and <b>VBA</b> Add-ins, in an 80+ project migration. My other work has been
                  in <b>mobile game development</b> targetting both IOS/Android at and in <b>data management/processing optimizations</b> in Java. I still work on personal projects, like designing game mechanics in <b>Godot</b> or <b>Unity</b>, exploring AR projects for mobile devices, or when I need a break from screens, I'm cross-stitching!
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>My Skillsets</Accordion.Header>
                <Accordion.Body>
                  ● Languages: C#/.NET, Python, Java, JavaScript/Typescript/HTML/CSS, VBA, C/C++, PHP, SQL/NoSQL
                  <br />
                  ● Frameworks and Libraries: Nintendo SDK, React.js, Robot Framework, JUNIT, NUNIT, D3, Angular.js, SignalR, Tizen OS, Node.js, Kinect SDK
                  <br />
                  ● Tools: Git, Perforce, Team Foundation Server, Jenkins, TeamCity, Tableau, Trifecta Wrangler, Hololens, Arduino
                  <br />
                  ● Game Engines: UE5, Unity, Godot, RenPy
                  <br />
                  <br />
                  <i>
                    Technology is always rapidly changing, so I excel at adapting to the latest language, tool, or framework required. The ones listed are my core/latest acquired skills but as a generalist, it is not exhaustive.
                  </i>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>My Education</Accordion.Header>
                <Accordion.Body>
                  I have a <b>Bachelor's degree in Computer Science</b> with a concentration in Human Computer Interactions (UI/UX) from the University of Calgary.
                  <br /><br />
                  I have a <b>Master's degree in Digital Media </b> from the Centre of Digital Media (SFU, UBC, BCIT, ECUAD Joint Graduate Program) in Vancouver. This was an intense graduate program that provided me the opportunity and experience working directly with diverse (technical/non-technical) teams such as designers, artists, product owners.
                  <br /><br />
                  I have a <b>DELF A2 Diploma</b> (Basic French Comprehension Diploma).
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <br />
          </div>
        </div>
      </div>

      <div className="parallax">
        <h2 className="animate__animated animate__fadeInDown ParallaxHeader">
          Featured Personal Projects
        </h2>
      </div>
      <MainCarousel />
    </div>
  );
}